module.exports = __webpack_public_path__ + "img/Instagram.4a249383.svg";